function t(t){return t.charAt(0).toUpperCase()+t.substring(1)}export{t as default};
